import { createFileRoute } from '@tanstack/react-router'

import { CustomFieldsSection } from '@/features/organization/custom-fields-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/campos')({
  component: CamposTab,
})

function CamposTab() {
  const { currentOrgId } = useAuth()
  return <CustomFieldsSection orgId={currentOrgId} />
}
